/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */
import {
    algoliaConfig,
    PRICE_GROUP_DEFAULT, PRICE_GROUPS_ENABLED,
    STORE_CODE_PLACEHOLDER
} from "@/app/config/algoliaConfig";
import {getCookie} from "@/app/utils/cookie";
import {STORE_CODE_COOKIE, USER_GROUP_COOKIE} from "@/app/constants";

export const transformAlgoliaSortOptions = (algoliaSortOptionsString?:string|null, defaultSortOptionLabel?:string) => {
    const algoliaSortOptions = algoliaSortOptionsString ? JSON.parse(algoliaSortOptionsString) : {};

    const userGroup = getCookie({name: USER_GROUP_COOKIE});
    const priceGroup = !PRICE_GROUPS_ENABLED || !userGroup || userGroup === 'null' ? PRICE_GROUP_DEFAULT : `group_${userGroup}`;
    const storeCode = getCookie({name: STORE_CODE_COOKIE}) ?? '';

    let dynamicSortOption:{value:string, label:string}[] = [];

    for (let key in algoliaSortOptions) {
        if(algoliaSortOptions[key]) {
            if(algoliaSortOptions[key].attribute === 'price' && algoliaConfig.priceGroups && priceGroup) {
                dynamicSortOption.push({
                    value: `${algoliaConfig.defaultProductIndex.replace(STORE_CODE_PLACEHOLDER, storeCode)}_${algoliaSortOptions[key].attribute}_${priceGroup}_${algoliaSortOptions[key].sort}`,
                    label: algoliaSortOptions[key].sortLabel,
                });
            } else {
                dynamicSortOption.push({
                    value: `${algoliaConfig.defaultProductIndex.replace(STORE_CODE_PLACEHOLDER, storeCode)}_${algoliaSortOptions[key].attribute}_${algoliaSortOptions[key].sort}`,
                    label: algoliaSortOptions[key].sortLabel,
                });
            }
        }
    }

    return [
        {value: algoliaConfig.defaultProductIndex.replace(STORE_CODE_PLACEHOLDER, storeCode), label: defaultSortOptionLabel ?? 'Position'},
        ...dynamicSortOption
    ];
}